export const TOKEN_PARAM = 't';
export const TOKEN_ATTRIBUTE = 'custom:invitation_token';
export const CLIENT_ATTRIBUTE = 'custom:client_id';
export const PREVENT_SIGNUP_ERROR_CODE = 'UserLambdaValidationException';
export const USER_DISABLED = 'GraphQL error: User is disabled';
export const USER_NOT_AUTHENTICATED = 'The user is not authenticated';
export const USER_NOT_CONFIRMED_EXCEPTION = 'UserNotConfirmedException';
export const PASSWORD_RESET_REQUIRED_EXCEPTION = 'PasswordResetRequiredException';
export const FORGOT_PASSWORD = 'forgotPassword';
export const ES_CLIENT = 'esClient';
export const ES_PATH_AND_QUERY = 'esPathAndQuery';
